import { ElementRef } from '@angular/core';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
const _c0 = a0 => ({ "show": a0 });
function QuickflowsPreferenceComponent_div_1_div_5_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 8)(2, "label", 3)(3, "input", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function QuickflowsPreferenceComponent_div_1_div_5_div_8_Template_input_ngModelChange_3_listener($event) { const quickflow_r6 = i0.ɵɵrestoreView(_r5).$implicit; i0.ɵɵtwoWayBindingSet(quickflow_r6.active, $event) || (quickflow_r6.active = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("click", function QuickflowsPreferenceComponent_div_1_div_5_div_8_Template_input_click_3_listener() { const quickflow_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r3 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r3.updateEnablement(quickflow_r6.active, quickflow_r6.internalName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 5);
    i0.ɵɵelementStart(5, "span", 9);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const quickflow_r6 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", quickflow_r6.active);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(quickflow_r6.label);
} }
function QuickflowsPreferenceComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "label", 3)(3, "input", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function QuickflowsPreferenceComponent_div_1_div_5_Template_input_ngModelChange_3_listener($event) { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; i0.ɵɵtwoWayBindingSet(category_r2.active, $event) || (category_r2.active = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("click", function QuickflowsPreferenceComponent_div_1_div_5_Template_input_click_3_listener() { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; const quickflowKey_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateCategoryEnablement(category_r2.active, category_r2.category, quickflowKey_r3)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵlistener("click", function QuickflowsPreferenceComponent_div_1_div_5_Template_div_click_5_listener() { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; const quickflowKey_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.displayCategory(category_r2.show, category_r2.category, quickflowKey_r3)); });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵtemplate(8, QuickflowsPreferenceComponent_div_1_div_5_div_8_Template, 7, 2, "div", 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", category_r2.active);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", category_r2.category, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, category_r2.show));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r2.quickflowsOfCategory);
} }
function QuickflowsPreferenceComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "div")(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(5, QuickflowsPreferenceComponent_div_1_div_5_Template, 9, 6, "div", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const quickflowKey_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(quickflowKey_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.quickflowsInfo[quickflowKey_r3]);
} }
export class QuickflowsPreferenceComponent {
    constructor(eltRef, urlsService, ajaxService) {
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.ajaxService = ajaxService;
        this.quickflows = {};
        this.quickflowsInfo = {};
        this.enabledQuickflows = [];
        this.quickflowKeys = ['Single', 'Comparison'];
        this.quickflowLabels = {};
        const quickflows = this.eltRef.nativeElement.getAttribute('quickflows');
        this.quickflows = JSON.parse(quickflows.replaceAll(`'`, `"`));
    }
    ngOnInit() {
        const accessUrl = this.urlsService.QUICKFLOWS.PREFERENCE.GET_ACCESS;
        this.ajaxService.getDataObserveBody(accessUrl).subscribe({
            next: (response) => {
                this.enabledQuickflows = response;
            },
            error: () => {
                this.quickflowsInfo = {};
            },
            complete: () => this.getQuickflowLabels(),
        });
    }
    getQuickflowLabels() {
        const labelsUrl = this.urlsService.QUICKFLOWS.LABELS;
        this.ajaxService.getDataObserveBody(labelsUrl).subscribe({
            next: (response) => {
                this.quickflowLabels = response;
            },
            error: () => {
                this.quickflowLabels = {};
            },
            complete: () => this.initializeQuickflowsInfo(),
        });
    }
    getCategory(categoryName, quickflowType) {
        const categoriesByType = this.quickflowsInfo[quickflowType];
        for (let i = 0; i < categoriesByType.length; i += 1) {
            const currentCategory = categoriesByType[i];
            if (currentCategory.category === categoryName) {
                return currentCategory;
            }
        }
        return null;
    }
    displayCategory(show, categoryName, quickflowType) {
        const category = this.getCategory(categoryName, quickflowType);
        category.show = !show;
    }
    updateCategoryEnablement(active, categoryName, quickflowType) {
        const category = this.getCategory(categoryName, quickflowType);
        const currentActiveStatus = !active;
        category.active = currentActiveStatus;
        const preferenceUrl = this.urlsService.QUICKFLOWS.PREFERENCE.UPDATE_ACCESS;
        for (let i = 0; i < category.quickflowsOfCategory.length; i += 1) {
            category.quickflowsOfCategory[i].active = currentActiveStatus;
            if (currentActiveStatus) {
                const putUrl = this.urlsService.getUrl(preferenceUrl, {
                    quickflowId: category.quickflowsOfCategory[i].internalName,
                });
                this.ajaxService.putDataObserveBody(putUrl, {}).subscribe(() => { });
            }
            else {
                const deleteUrl = this.urlsService.getUrl(preferenceUrl, {
                    quickflowId: category.quickflowsOfCategory[i].internalName,
                });
                this.ajaxService.deleteDataObserveBody(deleteUrl).subscribe(() => { });
            }
        }
    }
    updateEnablement(active, internalName) {
        const currentActiveStatus = !active;
        const preferenceUrl = this.urlsService.QUICKFLOWS.PREFERENCE.UPDATE_ACCESS;
        if (currentActiveStatus) {
            const putUrl = this.urlsService.getUrl(preferenceUrl, { quickflowId: internalName });
            this.ajaxService.putDataObserveBody(putUrl, {}).subscribe(() => { });
        }
        else {
            const deleteUrl = this.urlsService.getUrl(preferenceUrl, { quickflowId: internalName });
            this.ajaxService.deleteDataObserveBody(deleteUrl).subscribe(() => { });
        }
    }
    initializeQuickflowsInfo() {
        const typesOfQuickflows = Object.keys(this.quickflows);
        for (let i = 0; i < typesOfQuickflows.length; i += 1) {
            const quickflowType = typesOfQuickflows[i];
            // get quickflows by single security or multi security
            const categoriesByType = this.quickflows[quickflowType];
            // get categories of current quickflow type
            const categories = Object.keys(categoriesByType);
            const formattedQuickflowsByCategory = [];
            for (let j = 0; j < categories.length; j += 1) {
                const currentCategory = categories[j];
                const currentCategoryQuickflows = categoriesByType[currentCategory];
                const quickflowsOfCurrentCategory = [];
                for (let k = 0; k < currentCategoryQuickflows.length; k += 1) {
                    const currentQuickflow = currentCategoryQuickflows[k];
                    quickflowsOfCurrentCategory.push({
                        active: this.enabledQuickflows.indexOf(currentQuickflow) > -1,
                        category: categories[j],
                        internalName: currentCategoryQuickflows[k],
                        label: this.quickflowLabels[currentQuickflow],
                    });
                }
                formattedQuickflowsByCategory.push({
                    active: quickflowsOfCurrentCategory.every((quickflow) => quickflow.active),
                    category: categories[j],
                    quickflowsOfCategory: quickflowsOfCurrentCategory,
                    show: false,
                });
            }
            this.quickflowsInfo[quickflowType] = formattedQuickflowsByCategory;
        }
    }
}
QuickflowsPreferenceComponent.ɵfac = function QuickflowsPreferenceComponent_Factory(t) { return new (t || QuickflowsPreferenceComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.AjaxService)); };
QuickflowsPreferenceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuickflowsPreferenceComponent, selectors: [["ycn-quickflows-preference"]], decls: 2, vars: 1, consts: [[1, "custom-controls-stacked"], [4, "ngFor", "ngForOf"], [1, "d-flex"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", "ng-pristine", "ng-untouched", "ng-valid", "ng-empty", 3, "ngModelChange", "click", "ngModel"], [1, "custom-control-indicator"], [1, "dropdown-toggle", "ng-binding", 3, "click"], [1, "collapse", 3, "ngClass"], [1, "custom-controls-stacked", "ng-scope"], [1, "custom-control-description", "ng-binding"]], template: function QuickflowsPreferenceComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, QuickflowsPreferenceComponent_div_1_Template, 6, 2, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.quickflowKeys);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgModel], encapsulation: 2 });
